export default __webpack_public_path__ + "static/media/avgApparentPowerIcon.de9b62a1.svg";